import * as React from 'react';
import {StyleSheet, View, ViewStyle} from 'react-native';

import CreateBackgroundButton from './CreateBackgroundButton';

interface Props {
  onPress: () => void;
}

const BottomCreateBackgroundButton: React.FunctionComponent<Props> = props => {
  return (
    <View style={styles.container}>
      <CreateBackgroundButton {...props} />
    </View>
  );
};

export default React.memo(BottomCreateBackgroundButton);

const styles = StyleSheet.create({
  container: {
    left: 0,
    right: 0,
    position: 'absolute',
    bottom: 0,
    paddingBottom: 16,
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
  } as ViewStyle,
});
